import nativeHttp from '@/utils/native/http'

export interface Product {
  id: number
  productName: {
    en: string
    zh: string
    ko: string
    vi: string
  }
  originalPrice: number
  discountPrice: number
  originalUsdtPrice: number
  discountUsdtPrice: number
  ftPrice?: number
  ftUsdtPrice?: number
  weight: number
  trialCardInfo?: {
    count: 10
    experienceDays: 4
    validDays: 30
  }
}

export function getProductList() {
  return nativeHttp.post<Product[]>('user/product/listH5', { h5: true })
}
